import classNames from 'classnames';
import { LiveIcon } from '../../icons';
import styles from './styles.module.scss';

export interface ILiveControlProps {
  active: boolean;
  className?: string;
  onClick: () => void;
}

const LiveControl = ({ active, className, onClick }: ILiveControlProps) => {
  return (
    <button
      onMouseDown={(event) => event.preventDefault()}
      className={classNames(styles.liveControl, { [styles.active]: active }, className)}
      onClick={onClick}
    >
      <LiveIcon />
      Live
    </button>
  );
};

export default LiveControl;
